'use strict';

angular.module('services.config', [])
  .constant('configuration', {
    baseURL: '/mgp-corregedoria/',
    preferredLanguage: 'pt-BR'
  });

